// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shopping_note[data-v-499b8760]{min-height:calc(var(--vh, 1vh)*100 - 203px);background-size:cover;background-position:50%;background-repeat:no-repeat}.shopping_note-card[data-v-499b8760]{background-color:hsla(0,0%,100%,.9);padding:30px}", ""]);
// Exports
module.exports = exports;
